import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
// The centered footer link at the bottom of a list card (e.g. "View all 12
// teams →", "Build a Formation →"). Pass the full label including any arrow.
export const CardFooterLink = ({ to, label, }) => (_jsx(Box, { sx: {
        p: 2,
        textAlign: "center",
        backgroundColor: "rgba(25, 118, 210, 0.02)",
        borderTop: "1px solid rgba(0,0,0,0.08)",
        mt: 1,
    }, children: _jsx(Link, { to: to, style: { textDecoration: "none" }, children: _jsx(Typography, { variant: "body2", sx: {
                color: "primary.main",
                fontWeight: 600,
                "&:hover": { textDecoration: "underline" },
            }, children: label }) }) }));
